export default __webpack_public_path__ + "static/media/mbmi-green.43576201.png";